import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
const ClientInvoice = ()=>{
    const [clientInvoice, setClientInvoice] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`clientInvoice?page=${page}`);
            setClientInvoice(data.data);
            console.log(data);
            setLastPage(data.meta.last_page)

        }
        )();
    },[page]);
    const del = async (id) =>{
        if(window.confirm("Are you sure you want to delete this record?")){
            await axios.delete(`clientInvoice/${id}`);
            setClientInvoice(clientInvoice.filter((clientInvoice) => clientInvoice.id !== id));
        }
    }
    return (
        <Wrapper pageTitle={'Invoices'}>
            <InnerNav createLink={'/clientInvoiceCreate'} listLink={'/clientInvoice'} />
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    <div className="w-full overflow-x-auto">
                    {clientInvoice ? (
        clientInvoice.length > 0 ? (
                        <table className="w-full whitespace-no-wrap">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                    <th className="px-4 py-3">#Ref </th>
                                    <th className="px-4 py-3">Client </th>
                                    <th className="px-4 py-3">Product </th>
                                    <th className="px-4 py-3">Quantity </th>
                                    <th className="px-4 py-3">Total </th>
                                    <th className="px-4 py-3">Purchasedate </th>
                                     <th className="px-4 py-3">Action</th>
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >

                                    {clientInvoice.map((clientInvoice)=>{
                                         return(
                                             <tr key={clientInvoice.id} className="text-gray-700 dark:text-gray-400">
                                                 <td className="px-4 py-5">{clientInvoice.id}</td>
                                                 <td className="px-4 py-3 text-sm"><Link className="btn btn-sm btn-outline-secondary px-5" to={`/createInvoice/${clientInvoice.client.id}/pdf`}>{clientInvoice.client.name} </Link></td>
                                                 <td className="px-4 py-3 text-sm">{clientInvoice.product.name}</td>
                                                 <td className="px-4 py-3 text-sm">{clientInvoice.quantity}</td>
                                                 <td className="px-4 py-3 text-sm">{clientInvoice.total}</td>
                                                 <td className="px-4 py-3 text-sm">{clientInvoice.purchase_date}</td>
                                                 <td className="flex px-4 py-3 text-sm"><Link className="btn btn-sm btn-outline-secondary px-5" to={`/clientInvoice/${clientInvoice.id}/edit`}><AiFillEdit/> </Link><span className="btn btn-sm btn-outline-secondary" onClick={()=>del(clientInvoice.id)}> <AiFillDelete className="text-rose-500 text-lg"/></span></td>
                                             </tr>
                                         );
                                     })
                                 }
                            </tbody>
                        </table>
                          ) : (
                            <p>No data available</p>
                          )
                        ) : (
                          <p>Loading...</p>
                        )}
                    </div>
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                </div>
             </Wrapper>
         );
};
export default ClientInvoice;